class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseover', this.onHover.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.addEventListener('keydown', this.onSummaryKeyDown.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', 'false');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close(false);
    })
  }

  onHover(event) {
    event.preventDefault();
    this.open(event);
  }

  onSummaryClick(event) {
    const linkUrl = event.currentTarget.dataset.menuLink;

    if (!linkUrl || linkUrl === '#') return;
    if (event.detail === 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    window.location.href = linkUrl;
  }

  onSummaryKeyDown(event) {
    const linkUrl = event.currentTarget.dataset.menuLink;

    if (event.code.toUpperCase() !== 'ENTER' || !linkUrl || linkUrl === '#') return;

    event.preventDefault();
    window.location.href = linkUrl;
  }

  onMenuClose(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  closeSiblingDetails() {
    this.closest('nav')?.querySelectorAll('details[open]').forEach((details) => {
      if (details === this.mainDetailsToggle) return;
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  open() {
    this.closeSiblingDetails();
    this.onMenuCloseEvent =
      this.onMenuCloseEvent || this.onMenuClose.bind(this);
    this.mainDetailsToggle.setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onMenuCloseEvent);
    document.body.addEventListener('mouseover', this.onMenuCloseEvent);
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', isOpen.toString());

    if (isOpen) {
      this.closeSiblingDetails();
      this.onMenuCloseEvent =
        this.onMenuCloseEvent || this.onMenuClose.bind(this);
      document.body.addEventListener('click', this.onMenuCloseEvent);
      document.body.addEventListener('mouseover', this.onMenuCloseEvent);
    } else {
      document.body.removeEventListener('click', this.onMenuCloseEvent);
      document.body.removeEventListener('mouseover', this.onMenuCloseEvent);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    this.mainDetailsToggle.removeAttribute('open');
    document.body.removeEventListener('click', this.onMenuCloseEvent);
    document.body.removeEventListener('mouseover', this.onMenuCloseEvent);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
